import React, { useState, useCallback } from 'react';

interface UseControlledProps {
  controlledValue?: string;
  defaultUncontrolledValue?: string;
  onChange?: (newValue: string, e: React.ChangeEvent<HTMLInputElement>) => void;
}

// Значение и функция его изменения, возвращаемые в виде массива (аналогично useState).
type UseControlledResult = [string | undefined, (e: React.ChangeEvent<HTMLInputElement>) => void];

const useControlled = (props: UseControlledProps): UseControlledResult => {
  const { controlledValue, defaultUncontrolledValue = '', onChange } = props;

  // Внутреннее значение используется, если нет внешнего
  const [uncontrolledValue, setUncontrolledValue] = useState<string>(defaultUncontrolledValue);

  const isControlled = controlledValue !== undefined;

  const valueState = isControlled ? controlledValue : uncontrolledValue;

  const setValueState = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const str = e.target.value;

      if (!isControlled) setUncontrolledValue(str);

      onChange?.(str, e);
    },
    [isControlled, onChange]
  );

  return [valueState, setValueState];
};

export default useControlled;
